import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Row,
  Col,
  Layout,
  Form,
  Input,
  Upload,
  Button,
  Icon,
  Modal
} from 'antd'
import Header from '../Header'
import API from '../../api/index'

const { Content } = Layout

const ProfessionUpdate = (props) => {
  const id = props.match.params.id
  const [name, setName] = React.useState(undefined)
  const [name_verify, setName_verify] = React.useState(undefined)
  const [errorName, setErrorName] = React.useState(undefined)
  const [image, setImage] = React.useState(undefined)
  const [errorImage, setErrorImage] = React.useState(undefined)
  const [redirect, setRedirect] = React.useState(undefined)

  const onBack = () => {
    setRedirect('/profession')
  }

  const onSubmit = async () => {
    clearErrors()
    let nameTrue
    if (name_verify !== name) {
      nameTrue = name
    }
    const response = await API.profession.update(id, {
      name: nameTrue,
      image: image
    })
    if (response.ok) {
      Modal.success({
        title: 'Actualización de una profesión',
        content: `La profesión ${name} fue actualizada exitosamente`
      })
      clearErrors()
    }
    if (response.errors) {
      makeErrors(response.errors)
    }
  }

  const makeErrors = (error) => {
    if (error.name) {
      setErrorName(error.name.message)
    }
    if (error.image) {
      setErrorImage(error.image.message)
    }
  }

  const clearErrors = () => {
    setErrorName(undefined)
    setErrorImage(undefined)
  }

  const beforeUpload = () => {
    return false
  }

  const handleClearImage = async () => {
    setImage(undefined)
  }

  const getProfession = async () => {
    const profession = await API.profession.detail(id)
    setName(profession.name)
    setName_verify(profession.name)
    setImage(profession.image)
  }

  React.useEffect(() => {
    getProfession()
  }, [])

  if (redirect) {
    return (
      <Redirect to={redirect} />
    )
  }
  return (
    <Layout className='layout'>
      <Header item='profession' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <h3><strong>Actualización de la profesión</strong></h3>
            </Col>
            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
              <Button onClick={() => onBack()}>Regresar</Button>
              {' '}
              <Button onClick={() => onSubmit()}>Editar</Button>
            </Col>
          </Row>
          <Form
            layout='vertical'
          >
            <Row>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Nombre'
                  validateStatus={errorName && ('error')}
                  help={errorName}
                >
                  <Input
                    type='text'
                    name='name'
                    placeholder='Ingrese nombre de la profesión'
                    onChange={(event) => setName(event.target.value)}
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Imagen'
                  validateStatus={errorImage && ('error')}
                  help={errorImage}
                >
                  {!image ? (
                    <Upload
                      name='file'
                      listType='picture'
                      beforeUpload={() => beforeUpload()}
                      onChange={(event) => setImage(event.file)}
                    >
                      <Button><Icon type='upload' /> Seleccionar imagen</Button>
                    </Upload>
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Icon type='picture' theme='outlined' style={{ fontSize: '20px' }} />{' '}
                      <span style={{ paddingLeft: '10px', paddingRight: '10px' }}>{image.name}</span> {' '}
                      <Icon type='close' style={{ fontSize: '20px', color: 'red' }} onClick={() => handleClearImage()} />
                    </div>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
    </Layout>
  )
}
export default ProfessionUpdate